import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { DataCard, HomeCardsTypes } from './types';

export const loadRequest = () => action(HomeCardsTypes.LOAD_REQUEST);
export const loadSuccess = (data: DataCard[]) => action(HomeCardsTypes.LOAD_SUCCESS, { data });
export const loadFailure = (error: ResponseError) => action(HomeCardsTypes.LOAD_FAILURE, { error });
